import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./pages/login";
import Feed from "./pages/feed";
import Uploads from "./components/uploads";
import Profile from "./pages/profile";
import Messages from "./pages/messages";
import Layout from "./components/Layout";
import PrivateRoute from './components/PrivateRouting';

function App() {
  return (
    <Router>
      <Routes>
        {/* Apply Layout to all routes except /login */}
        <Route 
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
          >
          <Route path="/feed" element={<Feed />} />
          <Route path="/uploads" element={<Uploads />} />
          <Route path="/profile/:profileId" element={<Profile />} />
          <Route path="/messages" element={<Messages />} />
        </Route>

        {/* Login Page */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />} />
      </Routes>
    </Router>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
